import styled from '@emotion/styled'
import { Link } from 'gatsby'

const LogoLink = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
`

export default LogoLink
